import PostForm from '../../components/shared/PostForm';
import * as Yup from 'yup';
import MainLayout from '../../components/layouts/MainLayout';
import Breadcrumb from '../../components/shared/Breadcrumbs';
import Modal from '../../components/ui/Modal';
import useModal from '../../hooks/useModal'
import React, {  useState, useEffect} from 'react';
import  { useFetchShareHousePost } from '../../hooks/useFetchData';
import { useLocation } from 'react-router-dom';



const ShareHousePostForm = () => {
  const { data: sharehouse_post, loading, error } =  useFetchShareHousePost(); 
  const { isOpen, openModal, closeModal } = useModal();
  const [currentPage, setCurrentPage] = useState("");
  const [initialValues, setInitialValues] = useState(null);
  const location = useLocation(); 
  const params = new URLSearchParams(location.search);
  const id = params.get("id");
  const backUrl = process.env.REACT_APP_API_URL;


  useEffect(() => {
    if (id) {
      let available
      if( sharehouse_post.available = "即入入居可" ){
        available = new Date()
      }else{
        available = new Date(sharehouse_post.available)
      }

      if (isNaN(available)) {
        console.error('Invalid date:', available);
      }

      const customizedValues = {
        title: sharehouse_post.title || "",
        address: sharehouse_post.address || "",
        images: sharehouse_post.images || [],
        available: available,
        rent: sharehouse_post.rent || "",
        bond: sharehouse_post.bond || "",
        minimum: sharehouse_post.minimum || "",
        notice: sharehouse_post.notice || "",
        room: sharehouse_post.room != null ? sharehouse_post.room.toString() : "",
        gender: sharehouse_post.gender != null ? sharehouse_post.gender.toString() : "",
        couple: sharehouse_post.couple != null ? sharehouse_post.couple.toString() : "",
        equipment: sharehouse_post.equipment != null ? sharehouse_post.equipment.map(item => item.id).join(", ") : "",
        content: sharehouse_post.content || "",
        toll: sharehouse_post.toll !== undefined ? sharehouse_post.toll : false, // 'toll' が undefined の場合、false をデフォルトに
      };
      setInitialValues(customizedValues);
      console.log(customizedValues); // デバッグ用ログ
    }
  }, [sharehouse_post]);

  if (loading) return <p>Loading...</p>;
  if (error) {
    console.error('Error fetching sharehouse post data:', error);
  }

  const breadcrumbs = [
    { label: "Home", path: "/" },
    { label: "シェアハウス一覧", path: "/sharehouse" },
    { label: "投稿FORM", path: "/sharehouse_post" },
  ];
  const image_discription = [
    '画像の登録は10枚までです、それ以上の登録は無効となります。',
    <br />,
    '後からの画像の変更はできません'
  ]
  const formConfig={
    fields: [
      { name: 'title', type: 'text', label: 'Title', placeholder: 'タイトルを入力してください', validation: Yup.string().required('必須項目です') },
      { name: 'address', type: 'text', label: 'Address', placeholder: '住所を入力してください', validation: Yup.string().required('必須項目です'), description: '探しやすさ向上のためストリートまでの入力をお願い致します。' },
      { name: 'images', type: 'image', label: '画像', description: image_discription},
      { name: 'available', type: 'date', label: '入居開始可能日', placeholder: '日付を選択してください', validation: Yup.date().required('必須項目です') },
      { name: 'rent', type: 'number', label: 'Rent', placeholder: 'レントを入力してください', validation: Yup.number().nullable().required('必須項目です').typeError('数字を入力してください'), b_uint: '$' },
      { name: 'bond', type: 'number', label: 'Bond', placeholder: 'ボンドを入力してください', validation: Yup.number().required('必須項目です').typeError('数字を入力してください'), b_uint: '$' },
      { name: 'minimum', type: 'number', label: 'Minimum', placeholder: 'ミニマムを入力してください', validation: Yup.number().required('必須項目です').typeError('数字を入力してください'), a_uint: 'weeks' },
      { name: 'notice', type: 'number', label: 'Notice', placeholder: 'ノーチスを入力してください', validation: Yup.number().required('必須項目です').typeError('数字を入力してください'), a_uint: 'weeks' },
      { name: 'room', type: 'radio', label: '部屋タイプ', category: 'room', validation: Yup.string().required('必須項目です') },
      { name: 'gender', type: 'radio', label: '募集性別', category: 'gender', validation: Yup.string().required('必須項目です') },
      { name: 'couple', type: 'radio', label: 'カップル', category: 'couple', validation: Yup.string().required('必須項目です') },
      { name: 'equipment', type: 'checkbox', label: 'こだわり項目', category: 'equipment', description: '後からのこだわり項目の変更はできません'},
      { name: 'content', type: 'textbox', label: 'コンテンツ' },
      { name: 'toll', type: 'boolean', label: '有力枠に掲載する', initialValue: "False", description: 'チェックの入れられた投稿はお支払いの確認後上部表示、GC Koalaのインスタグラムでのご紹介をさせていただきます。詳しくは投稿完了時のご案内をご覧ください。'},
    ],
  }
  let type
  let apiUrl
  if(id){
    type = "editform";
    apiUrl = {submit: `${backUrl}/api/post_get/?type=sharehouse&id=${sharehouse_post.id}`};
  }else{
    type = "postform";
    apiUrl ={submit: `${backUrl}/api/post_get/?type=sharehouse`};
  }

  return (
    <>
    <MainLayout>
    <Breadcrumb items={breadcrumbs} />
    <PostForm
      title={'Share House'}
      formConfig={formConfig}
      type={type}
      apiUrl={apiUrl}
      openModal={openModal}
      setCurrentPage={setCurrentPage}
      initialValues={initialValues || formConfig.fields.reduce((acc, field) => {
        acc[field.name] = field.initialValue || (field.type === 'checkbox' ? [] : '');
        return acc;
      }, {})}
    />
    </MainLayout>
    <Modal isOpen={isOpen} closeModal={closeModal}>
    {currentPage === "post_comp" ?(
      <>
      <h2 className='login__ttl'>投稿が完了しました</h2>
      <div className='post__comp'>
        <span>投稿はMY PAGEよりいつでも編集・削除いただけます。</span>
        <span>募集が終了した際は、投稿の非表示への切り替えを忘れずにお願い致します。</span>
        <p>「有料枠に掲載する」に掲載するをチェックされた方には、GCkoala よりご登録のメールアドレス又はLNEにご案内を送らせていただきます。</p>
        <a href='/sharehouse'>一覧ページへ戻る</a>
        <a href='/mypage'>投稿を確認する</a>
      </div>
      </>
    ):currentPage === "edit_comp" ?(
      <>
      <h2 className='login__ttl'>編集が完了しました</h2>
      <div className='post__comp'>
        <span>投稿はMY PAGEよりいつでも編集・削除いただけます。</span>
        <span>募集が終了した際は、投稿の非表示への切り替えを忘れずにお願い致します。</span>
        <a href='/sharehouse'>一覧ページへ戻る</a>
        <a href='/mypage'>投稿を確認する</a>
      </div>
      </>
    ):(
      <></>
    )}
    </Modal>
    </>
  );
};
export default ShareHousePostForm;